import { render, staticRenderFns } from "./PointInventoryList.vue?vue&type=template&id=2857f9fc&scoped=true&"
import script from "./PointInventoryList.vue?vue&type=script&lang=js&"
export * from "./PointInventoryList.vue?vue&type=script&lang=js&"
import style0 from "./PointInventoryList.vue?vue&type=style&index=0&id=2857f9fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2857f9fc",
  null
  
)

export default component.exports